import axios from 'axios';
import { Encrypt } from './ENCS';
import { responseTypes } from '@/modules';
import { CONFIGS, Strg } from '@/Configs';
import { getAuthToken, getAuthTokenCk } from './Storage';
import { toast } from 'sonner';


export const Logout = async () => {
    let ss = await getAuthTokenCk();
    await localStorage.removeItem(Strg.tkes);
    toast.warning('Application Logout');
    window.location.replace('/auth');
    return;
};

export const POSTWITHAUTH = async ({ data, endPoint }: { data?: object, endPoint: string }): Promise<responseTypes> => {
    try {
        let token = await getAuthToken();
        if (!token || !token.success) {
            await Logout();
            return { success: false, message: 'No Auth, Please try to login again', data: {} };
        } else {
            let val = await axios({
                url: CONFIGS.apiBase + endPoint,
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token.data}`,
                },
                data: data || {},
            });
            if (val.data && val.data.apiStatus) {
                return { success: true, data: val.data.result, message: "" }
            } else {
                return { success: false, data: {}, message: val.data.message }
            }
        }
    } catch (error) {
        console.log(error)
        return { success: false, message: "Server Error!", data: {} }
    }
}


export const NOAUTHGET = async ({ data, endPoint }: { data?: object, endPoint: string }): Promise<responseTypes> => {
    try {
        let dd = {
            url: endPoint,
            header: {},
            params: data || {},
            method: "GET"
        }
        const enc = await Encrypt(JSON.stringify(dd));
        if (!enc.success) {
            return { success: false, message: 'Error in encsprt, Please try again', data: {} };
        }
        const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000";
        let val = await axios({
            url: baseUrl + '/api/backdoor',
            method: "POST",
            data: { encs: enc.data }
        });
        // let val = await axios({
        //     url: CommonConf.baseUrl + endPoint,
        //     method: 'GET',
        //     params: data || {},
        // });
        // console.log(val.data)
        if (val.data && val.data.apiStatus) {
            return { success: true, data: val.data.result, message: "" }
        } else {
            return { success: false, data: {}, message: val.data.message }
        }

    } catch (error) {
        console.log(error)
        return { success: false, message: "Server Error!", data: {} }
    }
}

export const NOAUTHPOST = async ({ data, endPoint }: { data?: object, endPoint: string }): Promise<responseTypes> => {
    try {
        let dd = {
            url: endPoint,
            header: {},
            data: data || {},
            method: "POST"
        }
        const enc = await Encrypt(JSON.stringify(dd));
        // console.log(enc)
        if (!enc.success) {
            return { success: false, message: 'Error in encsprt, Please try again', data: {} };
        }
        const baseUrl = process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000";
        // console.log(baseUrl)
        // let val = await axios({
        //     url: baseUrl + '/api/backdoor',
        //     method: "POST",
        //     data: { encs: enc.data }
        // });
        let val = await axios({
            url: CONFIGS.apiBase + endPoint,
            method: "POST",
            data: data || {},
        });
        if (val.data && val.data.apiStatus) {
            return { success: true, data: val.data, message: "" }
        } else {
            return { success: false, data: {}, message: val.data.message }
        }
    } catch (error) {
        console.log(error)
        return { success: false, message: "Server Error!", data: {} }
    }
}

export const NOAUTHPUT = async ({ data, endPoint }: { data?: object, endPoint: string }): Promise<responseTypes> => {
    try {
        let dd = {
            url: endPoint,
            header: {},
            data: data || {},
            method: "PUT"
        }
        const enc = await Encrypt(JSON.stringify(dd));
        if (!enc.success) {
            return { success: false, message: 'Error in encsprt, Please try again', data: {} };
        }
        let val = await axios({
            url: '/api/backdoor',
            method: "POST",
            data: { encs: enc.data }
        });
        // let val = await axios({
        //     url: CommonConf.baseUrl + endPoint,
        //     method: 'PUT',
        //     data: data || {},
        // });
        if (val.data && val.data.apiStatus) {
            return { success: true, data: val.data.result, message: "" }
        } else {
            return { success: false, data: {}, message: val.data.message }
        }
    } catch (error) {
        return { success: false, message: "Server Error!", data: {} }
    }
}